var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12181_2047)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.418264 10.3787L2.44466 11.0667V16.3256C2.44466 16.4551 2.48427 16.5813 2.55799 16.6868C2.6317 16.7922 2.73584 16.8717 2.85593 16.914L10.7953 19.7141C10.9208 19.7595 11.0575 19.7619 11.1846 19.7209L11.1931 19.7184L11.2023 19.7153L19.1441 16.914C19.2642 16.8717 19.3683 16.7922 19.442 16.6868C19.5157 16.5813 19.5553 16.4551 19.5553 16.3256V11.0667L21.5817 10.3787C21.6752 10.347 21.7598 10.2928 21.8283 10.2206C21.8967 10.1485 21.9471 10.0605 21.975 9.96426C22.0029 9.868 22.0075 9.7663 21.9885 9.66781C21.9695 9.56933 21.9275 9.47698 21.8659 9.39864L19.4215 6.28539C19.349 6.19343 19.2524 6.12433 19.1429 6.08615L11.1998 3.28423C11.0704 3.23859 10.9296 3.23859 10.8002 3.28423L2.85715 6.08615C2.74761 6.12433 2.65098 6.19343 2.57849 6.28539L0.134104 9.39864C0.0725286 9.47698 0.0304535 9.56933 0.0114633 9.66781C-0.00752699 9.7663 -0.00286926 9.868 0.0250396 9.96426C0.0529484 10.0605 0.103281 10.1485 0.171749 10.2206C0.240217 10.2928 0.32479 10.347 0.418264 10.3787ZM9.36165 12.9465L10.3889 11.4521V18.2533L3.66685 15.8823V11.4814L8.66806 13.18C8.79299 13.2223 8.928 13.2224 9.05298 13.1802C9.17795 13.138 9.28622 13.0564 9.36165 12.9465ZM4.92387 6.67455L11 8.81771L17.0761 6.67455L11 4.5314L4.92387 6.67455ZM12.6383 12.9471L11.6111 11.4515V18.2533L18.3332 15.8823V11.4814L13.3319 13.18C13.207 13.2223 13.072 13.2224 12.947 13.1802C12.822 13.138 12.7138 13.0558 12.6383 12.9459M3.26353 7.40679L1.63618 9.47958L5.00393 10.6234L8.62161 11.8519L10.0351 9.79526L9.95258 9.766L3.26353 7.40679ZM20.3638 9.47958L18.7365 7.40616L11.9649 9.79526L13.3784 11.8519L20.3638 9.47958Z",
    fill: "#50C878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12181_2047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInStock);
export default __webpack_public_path__ + "static/media/InStock.e60980942acff31985ff8ef3f6ce7c67.svg";
export { ForwardRef as ReactComponent };